import { PointF, PdfColor, PdfPen, PdfSolidBrush, PdfStandardFont, PdfFontFamily, PdfStringFormat, PdfTextAlignment, PdfFontStyle } from '@syncfusion/ej2-pdf-export';
import { pixelToPoint } from '../base/utils';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { PdfBorders } from './../export/pdf-base/pdf-borders';
export class EventMarker {
    constructor(parent) {
        this.renderHeight = 0;
        this.parent = parent;
    }
    drawEventMarker(page, startPoint, cumulativeWidth, detail, eventMarker, cumulativeHeight, ganttStyles) {
        const taskGraphics = page.graphics;
        const pageSize = page.getClientSize();
        let font = new PdfStandardFont(PdfFontFamily.Helvetica, 10);
        if (!isNullOrUndefined(this.parent.pdfExportModule['helper']['exportProps'].ganttStyle) &&
            this.parent.pdfExportModule['helper']['exportProps'].ganttStyle.font) {
            font = this.parent.pdfExportModule['helper']['exportProps'].ganttStyle.font;
        }
        /* eslint-disable-next-line */
        let strSize;
        if (!isNullOrUndefined(eventMarker.label)) {
            strSize = font.measureString(eventMarker.label);
        }
        const triangle = 8;
        const eventLine = ganttStyles.eventMarker.lineStyle;
        eventLine.dashStyle = ganttStyles.eventMarker.lineStyle.dashStyle;
        if (detail.startDate <= eventMarker.date && eventMarker.date <= detail.endDate) {
            const enventFormat = new PdfStringFormat();
            enventFormat.alignment = PdfTextAlignment.Center;
            const textFormat = !isNullOrUndefined(ganttStyles.eventMarker.label.format) ?
                ganttStyles.eventMarker.label.format : enventFormat;
            const eventBrush = new PdfSolidBrush(ganttStyles.eventMarker.label.backgroundColor);
            const fontColor = (ganttStyles.eventMarker.label && ganttStyles.eventMarker.label.fontColor) ?
                new PdfSolidBrush(ganttStyles.eventMarker.label.fontColor) : null;
            let customizedFont = this.getPdfFont(ganttStyles);
            if (isNullOrUndefined(customizedFont)) {
                customizedFont = font;
            }
            let defaultBorder = ganttStyles.eventMarker.label.borders ? ganttStyles.eventMarker.label.borders : null;
            if (ganttStyles.eventMarker.label.borderColor) {
                const pdfborders = new PdfBorders();
                pdfborders.all = new PdfPen(new PdfColor(ganttStyles.eventMarker.label.borderColor));
                defaultBorder = pdfborders;
            }
            const border = (!isNullOrUndefined(defaultBorder) && !isNullOrUndefined(defaultBorder.left)) ? defaultBorder.left : null;
            let padding = { left: 0, right: 0, top: 0, bottom: 0 };
            if (!isNullOrUndefined(ganttStyles) && !isNullOrUndefined(ganttStyles.eventMarker) &&
                !isNullOrUndefined(ganttStyles.eventMarker.label) && !isNullOrUndefined(ganttStyles.eventMarker.label.padding)) {
                padding = ganttStyles.eventMarker.label.padding;
            }
            const customizedFontBrush = !isNullOrUndefined(ganttStyles.eventMarker.label.fontBrush) ?
                new PdfPen(ganttStyles.eventMarker.label.fontBrush) : null;
            const left = this.parent.dataOperation.getTaskLeft(this.parent.dateValidationModule.getDateFromFormat(eventMarker.date, true), false, this.parent.defaultCalendarContext, true);
            const diff = 10;
            if (this.parent.pdfExportModule.gantt.taskbar.isAutoFit()) {
                taskGraphics.drawLine(eventLine, new PointF(startPoint.x + (left - cumulativeWidth) + diff, cumulativeHeight), new PointF(startPoint.x + (left - cumulativeWidth) + diff, this.renderHeight));
                if (!isNullOrUndefined(eventMarker.label) && eventMarker.label.length > 0) {
                    const renderBox = cumulativeHeight + pixelToPoint(parseFloat(eventMarker.top)) + (strSize.height * 2);
                    if (renderBox < this.renderHeight) {
                        taskGraphics.save();
                        taskGraphics.translateTransform(startPoint.x + (left - cumulativeWidth) + 7 + diff, cumulativeHeight +
                            pixelToPoint(parseFloat(eventMarker.top)) + strSize.height / 2);
                        taskGraphics.rotateTransform(45);
                        taskGraphics.drawRectangle(border, eventBrush, 0, 0, triangle, triangle);
                        taskGraphics.restore();
                        taskGraphics.drawRectangle(border, eventBrush, startPoint.x + (left - cumulativeWidth) + 7 + diff, cumulativeHeight + pixelToPoint(parseFloat(eventMarker.top)), strSize.width + 10, strSize.height * 2);
                        taskGraphics.drawString(eventMarker.label, customizedFont, customizedFontBrush, fontColor, (startPoint.x +
                            (left - cumulativeWidth) + 12 + diff) - (padding.left + padding.right), (cumulativeHeight + pixelToPoint(parseFloat(eventMarker.top)) +
                            pixelToPoint(strSize.height / 2)) - (padding.top + padding.bottom), strSize.width, strSize.height, textFormat);
                    }
                }
            }
            else {
                taskGraphics.drawLine(eventLine, new PointF(startPoint.x + pixelToPoint(left - cumulativeWidth) + diff, cumulativeHeight), new PointF(startPoint.x + pixelToPoint(left - cumulativeWidth) + diff, this.renderHeight));
                if (!isNullOrUndefined(eventMarker.label) && eventMarker.label.length > 0) {
                    const renderBox = cumulativeHeight + pixelToPoint(parseFloat(eventMarker.top)) + (strSize.height * 2);
                    if (renderBox < this.renderHeight) {
                        taskGraphics.save();
                        taskGraphics.translateTransform(startPoint.x + pixelToPoint(left - cumulativeWidth) + 7 + diff, cumulativeHeight + pixelToPoint(parseFloat(eventMarker.top)) + strSize.height / 2);
                        taskGraphics.rotateTransform(45);
                        taskGraphics.drawRectangle(border, eventBrush, 0, 0, triangle, triangle);
                        taskGraphics.restore();
                        taskGraphics.drawRectangle(border, eventBrush, startPoint.x + pixelToPoint(left - cumulativeWidth) + 7 + diff, cumulativeHeight + pixelToPoint(parseFloat(eventMarker.top)), strSize.width + 10, strSize.height * 2);
                        taskGraphics.drawString(eventMarker.label, customizedFont, customizedFontBrush, fontColor, (startPoint.x + pixelToPoint(left - cumulativeWidth) + 12 + diff) - (padding.left + padding.right), (cumulativeHeight + pixelToPoint(parseFloat(eventMarker.top) + 1) +
                            pixelToPoint(strSize.height / 2)) - (padding.top + padding.bottom), strSize.width, strSize.height, textFormat);
                    }
                }
            }
        }
    }
    getPdfFont(ganttStyle) {
        let font;
        if (ganttStyle && ganttStyle.eventMarker && ganttStyle.eventMarker.label &&
            (ganttStyle.eventMarker.label.fontSize || ganttStyle.eventMarker.label.fontStyle ||
                ganttStyle.eventMarker.label.fontFamily)) {
            const fontSize = ganttStyle.eventMarker.label.fontSize ? ganttStyle.eventMarker.label.fontSize : 9;
            const fontFamily = ganttStyle.eventMarker.label.fontFamily ?
                ganttStyle.eventMarker.label.fontFamily : this.fontFamily;
            const fontStyle = ganttStyle.eventMarker.label.fontStyle ?
                ganttStyle.eventMarker.label.fontStyle : PdfFontStyle.Regular;
            font = new PdfStandardFont(fontFamily, fontSize, fontStyle);
        }
        return font;
    }
}
